import React from 'react';

const BuyMeACoffee = () => {
    return (
        <a href="https://www.buymeacoffee.com/izzutech"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block transition-transform hover:scale-105 hover:shadow-lg rounded-lg overflow-hidden">
            <img
                style={{ height: "50px" }}
                alt="Buy Me a Coffee Widget"
                src="/bmc-button.png"
            />
        </a>
    );
};

export default BuyMeACoffee;